import { currencyConstants } from './currencyConstants.ts';

export const getCurrencySymbol = (currencyENUM: string | null | undefined): string | null => {
    return currencyENUM ? currencyConstants.symbols[currencyENUM] : null;
};
